export const heatmapKey = (raw) => {
  try {
    const url = new URL(raw);
    if (url.protocol !== "http:" && url.protocol !== "https:") return raw.replace(/\/$/, "");
    const params = [...url.searchParams.entries()].filter(([key]) => !key.startsWith("utm_")).sort();
    const query = new URLSearchParams(params).toString();
    return url.origin + url.pathname.replace(/\/$/, "") + (query ? `?${query}` : "") + url.hash;
  } catch {
    return (raw || "").replace(/\/$/, "");
  }
};

export const heatColor = (clicks, maxClicks) => {
  if (!clicks || clicks <= 0 || maxClicks <= 0) return null;
  const hue = 140 - 140 * (clicks / maxClicks);
  return `hsl(${Math.round(hue)}, 85%, 48%)`;
};

export const paintLinkHeatmap = (doc, stats, maxClicks) => {
  if (!doc) return;

  doc.querySelectorAll("a").forEach((anchor) => {
    if (anchor.dataset.heatPainted) return;
    const stat = stats.get(heatmapKey(anchor.getAttribute("href") || ""));
    if (!stat) return;
    anchor.dataset.heatPainted = "1";

    const color = heatColor(stat.clicks, maxClicks);
    anchor.style.pointerEvents = "none";
    anchor.style.borderRadius = "3px";
    anchor.style.padding = "1px 2px";
    anchor.style.backgroundColor = color;
    anchor.style.boxShadow = `0 0 0 2px ${color}`;

    const badge = doc.createElement("span");
    badge.textContent = stat.clicks.toLocaleString();
    badge.style.cssText =
      "display:inline-block;min-width:14px;margin-left:4px;padding:0 6px;border-radius:9px;" +
      "background:#111827;color:#fff;font:600 11px/18px system-ui,sans-serif;text-align:center;vertical-align:middle;";
    anchor.appendChild(badge);
  });
};
